import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../../../utils/Translate';

import availableIcon from '../../../../assets/css/eva/resources/images/available.svg';
import pendingIcon from '../../../../assets/css/eva/resources/images/pending.svg';

import './LoyaltyPoints.css';

export const LoyaltyPoints = ({ availablePoints, pendingPoints, isSummary }) => (
  <div className={`loyalty-points-container ${isSummary ? '-summary' : ''}`}>
    <div className="loyalty-points">
      <div className="loyalty-points-title">
        <span>{Translate.message('loyalty-points.points.available')}</span>
      </div>
      <div className="loyalty-points-value">
        <img src={availableIcon} alt="Points available" className="points-icon"/>
        <span className="points-value">{availablePoints}</span>
      </div>
    </div>
    <div className="loyalty-points">
      <div className="loyalty-points-title">
        <span>{Translate.message('loyalty-points.points.pending')}</span>
      </div>
      <div className="loyalty-points-value">
        <img src={pendingIcon} alt="Points pending" className="points-icon"/>
        <span className="points-value">{pendingPoints}</span>
      </div>
    </div>
  </div>
);

LoyaltyPoints.defaultProps = {
  isSummary: false
};

LoyaltyPoints.propTypes = {
  availablePoints: PropTypes.number.isRequired,
  pendingPoints: PropTypes.number.isRequired,
  isSummary: PropTypes.bool,
};
